import {
    server
} from "@/api";

const prefix = 'api/companies'

const adminPrefix = 'api/admin/companies'

export const admin = {
    create: async (company) => {
        return await server().post(adminPrefix, company, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    all: async (params) => {
        return await server().get(`${adminPrefix}/all`, { params });
    },
    get: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}`, { params });
    },
    paginate: async (params) => {
        return await server().get(adminPrefix, { params });
    },
    update: async (id, company) => {
        return await server().post(`${adminPrefix}/${id}`, company, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    destroy: async (id) => {
        return await server().delete(`${adminPrefix}/${id}`);
    },
    edit: async (id) => {
        return await server().get(`${adminPrefix}/${id}/edit`);
    }
}


export const create = async (company) => {
    return await server().post(prefix, company)
}

export const all = async (params) => {
    return await server().get(`${prefix}/all`, { params });
}

export const get = async (id, params = {}) => {
    return await server().get(`${prefix}/${id}`, { params });
}

export const paginate = async (params) => {
    return await server().get(prefix, { params });
}

export const update = async (id, company) => {
    return await server().post(`${prefix}/${id}`, company);
}

export const compnayProducts = async (id) => {
    return await server().get(`${prefix}/${id}/products`);
}

export const companyServices = async (id) => {
    return await server().get(`${prefix}/${id}/services`);
}


const companyApi = {
    create,
    get,
    all,
    update,
    paginate,
    compnayProducts,
    companyServices,
    admin
};

export default companyApi;